<template>
    <div>
        <BreadCrumbs v-bind:bcrumbs="bcrumbs" />
        <PageTitle v-bind:title="title" v-bind:admin="false" />
        <ErrorMessage v-if="errors.load" :error="errors.load" class="mt-2" />        
        <Loader v-if="loading" />
        <div v-else class="my-8 max-w-4xl mx-auto">
            <form class="space-y-4">

                <input type="hidden" name="id" v-model="data.id" />

                <!-- для "Школы пациентов" название не показываем! -->
                <div v-if="data.id != 1">
                    <label for="name" class="block text-sm font-medium text-gray-700">Название</label>
                    <div class="mt-1">
                        <input  type="text" v-model="data.name" name="name" id="name" autocomplete="name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                        <p v-if="errors.validationEdit && errors.validationEdit.name" class="mt-2 text-sm text-red-600" >
                            {{ errors.validationEdit.name[0] }}
                        </p>
                    </div>
                </div>

                <!-- для "Школы пациентов" дату не показываем! -->
                <div v-if="data.id != 1">
                    <label for="adate" class="block text-sm font-medium text-gray-700">Дата</label>
                    <div class="mt-1">
                        <input  type="date" v-model="data.adate" name="adate" id="adate" autocomplete="name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                        <p v-if="errors.validationEdit && errors.validationEdit.adate" class="mt-2 text-sm text-red-600" >
                            {{ errors.validationEdit.adate[0] }}
                        </p>
                    </div>
                </div>



                <div>
                    <div class="flex justify-end">
                        <button @click.prevent="save()" type="submit" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                            Сохранить изменения
                        </button>
                    </div>
                    <ErrorMessage v-if="errors.save" :error="errors.save" class="mt-2" />
                </div>



                <!-- для "Школы пациентов" превью не показываем! -->
                <div v-if="data.id != 1">
                    <label for="text" class="block text-sm font-medium text-gray-700">Превью (будет отображаться в списке статей):</label>
                    <Editor
                        api-key="API_KEY"
                        v-model="data.description"
                        :init="{
                            height: 800,
                            skin: 'oxide-dark',
                            plugins: 'wordcount',
                            image_advtab: true,
                            automatic_uploads: true,
                            file_picker_types: 'image',
                            images_upload_handler: uploadImage,
                        }"
                        plugins="image link insertdatetime table emoticons media"
                        toolbar="image link insertdatetime table emoticons media"
                    />
                </div>


                <div>
                    <label for="text" class="block text-sm font-medium text-gray-700">Полный текст:</label>
                    <Editor
                        api-key="API_KEY"
                        v-model="data.text"
                        :init="{
                            height: 800,
                            skin: 'oxide-dark',
                            plugins: 'wordcount',
                            image_advtab: true,
                            automatic_uploads: true,
                            file_picker_types: 'image',
                            images_upload_handler: uploadImage,
                        }"
                        plugins="image link insertdatetime table emoticons media"
                        toolbar="image link insertdatetime table emoticons media"
                    />
                </div>


            </form>


        </div>
    </div>
  
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import BreadCrumbs from "@/components/BreadCrumbs";
import PageTitle from "@/components/PageTitle";
import ErrorMessage from "../components/ErrorMessage";
import Editor from "@tinymce/tinymce-vue";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            loading: true,
            errors: { load: '', save: '', validationEdit: {} },
            bcrumbs: '',
            title: '',
            data: null,
        }
    },
    mounted() 
    {
        this.loadData()
    },
    computed: {
        ...mapGetters({
            user: "auth/user",
        }),
    },
    methods: {
        async loadData() 
        {
            this.errors.load = "";
            this.loading = true;
            if (this.user.is_cm != 1)
            {
                this.errors.load = "Ошибка при загрузке данных [cm1]";
                return
            }
            try {
                this.loading = true;
                // если параметр == -1, то создаём новую статью:
                if (this.$route.params.id == -1)
                {
                    this.data = {}
                    this.data.id = -1;
                    this.data.name = '';
                    this.data.adate = null;
                    this.data.description = '';
                    this.data.text = '';
                    this.bcrumbs = { articles_list: 0 };
                    this.title = 'Новая статья'
                }
                else
                // иначе - редактируем:
                {
                    this.title = 'Редактирование'
                    let response = await axios.get("articles/"+this.$route.params.id+"/edit");
                    this.data = response.data.article;
                    this.data.adate = moment(this.data.adate).format("YYYY-MM-DD");
                    
                    if (this.data.id == 1) {
                        this.title = 'Школа для пациентов [редактирование]'
                        this.bcrumbs = ''
                    }
                    else {
                        this.title = 'Редактирование статьи'
                        this.bcrumbs = response.data.bcrumbs
                    }
                }
                this.loading = false;
            } catch (e) {
                this.errors.load = "Ошибка при загрузке данных";
            }
        },


        async save() 
        {
            this.errors.validationEdit = {};
            this.errors.save = "";
            try {
                let response = await axios.post(
                    "articles/" + this.data.id,
                    Object.assign(this.data, { _method: "PUT" })
                );
                if (response.status == 200) {
                    // если мы сохранили (ну т.е. создали) новую статью, то переходим на страницу её редактирования:
                    if (this.$route.params.id == -1)
                    {
                        let id = response.data.id;
                        console.log('-= id =-',id)
                        if (id)
                        {
                            this.$router.replace({path: "/article/"+id+"/edit"});
                        }
                    }
                    // иначе (если редактировали существующую) - просто перезагружаем данные:
                    else
                    {
                        this.loadData();
                    }
                }
            } catch (e) {
                if (e.response.status == 422) 
                {
                    this.errors.validationEdit = e.response.data.errors;
                } 
                else if (e.response.status == 520) 
                {
                    this.errors.save = e.response.data.error;
                } else 
                {
                    this.errors.save = "Неизвестная ошибка при редактировании записи.";
                }
            }
        },

        //
        // Загрузка изображения в статью (в редакторе).
        //
        uploadImage(blobInfo, success, failure) 
        {
            this.errors.uploadfile = "";
            const config = { "content-type": "multipart/form-data" };
            const formData = new FormData();
            formData.append("file", blobInfo.blob(), blobInfo.filename());
            axios.post(
                "articles/" + this.data.id + "/uploadimage",
                formData,
                config
            )
            .then((response) => {
                success(response.data.location);
            })
            .catch((error) => {
                failure("HTTP Error." + error.response.data.errors.file[0]);
                if (error.response.status == 520) 
                {
                    this.errors.uploadfile = error.response.data.error;
                } 
                else 
                {
                    this.errors.uploadfile = "Неизвестная ошибка при загрузке файла.";
                }
            });
        },



    },
    components: {
        Loader,
        BreadCrumbs,
        PageTitle,
        ErrorMessage,
        Editor,
    },
}
</script>